import Presenter from './Presenter';
import { IContainerProps } from './types';

const MapContainer = (props: IContainerProps) => {

    return (
        <Presenter {...props} />
    );
};

export default MapContainer;
